import { UserInfo } from 'types'; // Assuming you have a types file defining UserInfo interface

export const hasPermission = (userInfo: UserInfo, permissionName: string): boolean => {
  return userInfo.roles.some(role =>
    role.permissions.some(permission => permission.name === permissionName)
  );
};
